import { create } from 'zustand'

import { functionsCardDraftEntry } from './functions-card-draft-entry'
import { functionsSettings } from './functions-settings'
import {
  type AllowedCardTypesBulkImport,
  type BulkImportStore,
  type SettingsBulkImport,
} from './bulk-import.store.types'
import { functionsBulkImport } from './functions-cards'

import { LeniencyCard } from '@/models/card-activity/card-activity.model'

const BASE_SETTINGS_IMPORT_BULK: SettingsBulkImport = {
  language: 'en',
  defaultLanguage: 'en',
  generateTranslations: true,
  selectType: 'single',
  generateAnswers: false,
  points: 1,
  grading: {
    method: 'simple',
    rubricId: '',
    performanceExpectations: '',
    leniency: LeniencyCard.NORMAL,
    gradingCriteriaWithAI: true,
    studentLevel: 'beginner',
    aiFocus: 'language',
    standardId: null,
    target_proficiency_level: null,
  },
  feedback: [],
  feedbackLanguage: 'native',
}

const INIITIAL_STATE_IMPORT_BULK: BulkImportStore = {
  cardType: 'idle',
  step: 1,
  cards: new Map(),
  cardsDraft: new Map(),
  selectedCards: [],
  loading: false,
  openModalBulk: false,
  modalBulkIsLoading: false,
  modalBulkType: null,
  settings: BASE_SETTINGS_IMPORT_BULK,
  open: false,
}

export const useBulkImportStoreBase = create<BulkImportStore>()(() => INIITIAL_STATE_IMPORT_BULK)

const toggleBulkImportModal = (
  defaultLanguage?: string,
  rubricId?: string,
  language?: string,
  cardType?: AllowedCardTypesBulkImport,
  step?: 1 | 2 | 3,
) => {
  useBulkImportStoreBase.setState(state => {
    return {
      ...state,
      open: !state.open,
      cardType: cardType ?? 'idle',
      step: step ?? 1,
      settings: {
        ...state.settings,
        language: language ?? 'en',
        defaultLanguage: defaultLanguage ?? 'en',
        grading: { ...state.settings.grading, rubricId: rubricId ?? '' },
      },
    }
  })
}

const updateImportBulkStore = (newState: Partial<BulkImportStore>) => {
  useBulkImportStoreBase.setState(state => {
    return {
      ...state,
      ...newState,
    }
  })
}

const handleNextStep = () => {
  useBulkImportStoreBase.setState(state => {
    const newStep = state.step + 1

    if (state.step === 3) return state

    return {
      ...state,
      step: newStep as 1 | 2 | 3,
    }
  })
}

const handlePreviousStep = () => {
  useBulkImportStoreBase.setState(state => {
    const newStep = state.step - 1

    if (state.step === 1) return state

    return {
      ...state,
      step: newStep as 1 | 2 | 3,
    }
  })
}

export const bulkImportStoreActions = {
  updateImportBulkStore,
  toggleBulkImportModal,
  handleNextStep,
  handlePreviousStep,

  ...functionsCardDraftEntry,
  ...functionsSettings,
  ...functionsBulkImport,
}
